import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import {
  UPDATE_PROJECT,
  UPDATE_REVISIONS,
  UPDATE_CURRENT_REVISION,
  CLEAR_PROJECT,
  CLEAR_REVISIONS,
  CLEAR_CURRENT_REVISION,
  UPDATE_DIALOG_ACTIVE,
  UPDATE_ACTION_TYPE
} from './constants'
import * as R from 'ramda'
import P from 'helpers/predicates'

const updateProject = (prev, { revision, project }) => ({
  ...prev,
  [revision]: project
})
const updateCurrentRevision = (prev, { revision }) => revision.toString()
const updateRevisions = (prev, { revisions }) => ({
  ...prev,
  ...revisions
})
const updateDialogActive = (prev, { active }) => P.isNotNil(active)
  ? active
  : prev

const updateActionType = (prev, { actionType }) => P.isNotNil(actionType)
  ? actionType
  : prev

const currentRevision = createReducer(null, {
  [CLEAR_CURRENT_REVISION]: () => null,
  [UPDATE_CURRENT_REVISION]: updateCurrentRevision
})

const revisions = createReducer({}, {
  [CLEAR_REVISIONS]: () => ({}),
  [UPDATE_REVISIONS]: updateRevisions
})

const projects = createReducer({}, {
  [CLEAR_PROJECT]: () => ({}),
  [UPDATE_PROJECT]: updateProject
})

const active = createReducer(R.F(), {
  [UPDATE_DIALOG_ACTIVE]: updateDialogActive
})

const actionType = createReducer(null, {
  [UPDATE_ACTION_TYPE]: updateActionType
})

export {
  currentRevision,
  revisions,
  projects,
  active,
  actionType
}
